import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material';
import { GridCellParams } from '@mui/x-data-grid';
import { WhiteTooltip } from '@AMIEWEB/Common';
import { checkOverlapForArray } from '../helper';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { selectEditTimeOffRows } from 'store/redux-store/placement-mods/selectors';

const StyledTootltip = makeStyles()((theme: Theme) => ({
  arrow: {
    '&:before': {
      border: '1px solid #E3DFDF',
    },
    color: theme.palette.components.tooltip.arrowColor,
  },
  truncation: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  tooltipContent: {
    backgroundColor: theme.palette.components.tooltip.backgroundColor,
    border: '1px solid #E3DFDF',
    color: theme.palette.system.errorRed,
    fontWeight: 'normal',
  },
}));

export const CustomTooltipCellRenderer = React.memo(function CustomTooltipCellRenderer(cellParams: any) {
  const { classes } = StyledTootltip();
  const timeOffEditRequests = useSelector(selectEditTimeOffRows);
  const getTitle = props => {
    if (moment(props?.row.startDate) > moment(props?.row.endDate)) {
      return 'Must be before end date';
    } else if (checkOverlapForArray(timeOffEditRequests, props)) {
      return 'Overlaps with an existing record';
    } else if (props?.row?.endDate === '--' || !props?.row?.endDate) {
      return 'required';
    } else {
      return '';
    }
  };
  const getEndDate = endDate => {
    return endDate.row?.endDate ? moment(endDate.row?.endDate).format('MM/DD/YYYY') : '--';
  };

  return (
    <WhiteTooltip
      arrow={true}
      title={getTitle(cellParams)}
      classes={{ tooltip: classes.tooltipContent, arrow: classes.arrow }}
    >
      <span className={classes.truncation}>{getEndDate(cellParams)}</span>
    </WhiteTooltip>
  );
});

export const EndDateToolTip = (params: GridCellParams) => {
  return <CustomTooltipCellRenderer {...params} />;
};
